<template>
  <v-content class="">
    <section>
      <v-parallax
        :src="require('@/assets/beach-tsv2.jpg')"
        height="500"
        class="banner"
      >
        <Navbar></Navbar>

        <v-layout column class="white--text " justify-end>
          <div>
            <v-container justify-end>
              <div class=" display-1  mt-3 subpage-heading-1 ">
                Learn about damage to ancillary items in the grounds and on
                buildings
              </div>
              <div class=" headline  mt-3 subpage-heading-2 ">
                General information about ancillary damage
              </div>
            </v-container>
          </div>
        </v-layout>
      </v-parallax>
    </section>

    <section>
      <v-container class=" white-background">
        <v-breadcrumbs divider="-">
          <v-breadcrumbs-item @click="gotoDamage">Damage</v-breadcrumbs-item>
          <v-breadcrumbs-item  > </v-breadcrumbs-item>
          <v-breadcrumbs-item @click="gotoAncillary"
            >Ancillary Items</v-breadcrumbs-item
          >
        </v-breadcrumbs>
        <v-layout column wrap class="" align-center>
          <v-flex xs12 class="my-3">
            <div class="text-xs-center">
              <h2 class="headline pa-2">
                Damage to Ancillary Items in the Grounds and on Buildings
              </h2>
              <span class="subheading pa-2"> General Information</span>
            </div>
            <div>
              <p class="pl-2 pr-2 pt-2">
                Items in the grounds of properties such as fences, shade cloth
                structures, swimming pools, sheds, walkways, patios etc. are
                vulnerable to damage from wind forces and wind-borne debris. If
                they are damaged, they can also become debris and damage parts
                of buildings on the property or other items in the grounds.
              </p>

              <p class="pl-2 pr-2 pt-2">
                Roof top ancillary items such as aerials, PVC panels, air
                conditioning units are also vulnerable to damage during a
                cyclone. The larger the number of ancillary items on a building,
                the more susceptible the building is to potential damage during
                a cyclone.
              </p>

              <p class="pl-2 pr-2 pt-2">
                In some cases, the damage to the ancillary item can cause small
                holes in the cladding, which leads to water damage inside the
                building. In other cases, the damage to the ancillary item can
                cause substantial wind damage to the building cladding.
              </p>
            </div>
          </v-flex>
          <v-flex style=" width: 100%">
            <v-carousel style="height: 100%; width: 100%" :cycle="cycle" dark>
              <v-carousel-item
                v-for="(item, i) in ancillaryItems"
                :src="item.name"
                :key="i"
              >
                <v-responsive dark>
                  <v-container fill-height>
                    <v-layout align-center>
                      <v-flex aling-start justify-center>
                        <h3 class="display-1 white--text">
                          {{ item.heading }}
                        </h3>
                        <span class="subheading white--text font-weight-bold">{{
                          item.text
                        }}</span>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-responsive>
              </v-carousel-item>
            </v-carousel>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
    <Footer></Footer>
  </v-content>
</template>

<style>
  .v-breadcrumbs__item{
    color: #1976D2;
    cursor: pointer;
  }
</style>

<script>
import Navbar from "./Navbar.vue";
import Footer from "./Footer.vue";
import { router } from "../router";

import image1 from "../assets/27_ancillary.jpg";
import image2 from "../assets/28_ancillary.jpg";
import image3 from "../assets/30_ancillary.jpg";
import image4 from "../assets/31_ancillary.jpg";
import image5 from "../assets/33_ancillary.jpg";
import image6 from "../assets/34_ancillary.jpg";
import image7 from "../assets/35_ancillary.jpg";

export default {
  name: "Ancillary",
  components: {
    Navbar,
    Footer
  },
  data: () => ({
    size: "sm",
    cycle: false,
    ancillaryItems: [
      {
        name: image7,
        heading: "Shed Damage",
        text: "Damage to shed"
      },
      {
        name: image2,
        heading: "Pool Fence Damage",
        text: "Damage to glass pool fences"
      },
      {
        name: image3,
        heading: "Sail Cloth Damage",
        text: "Damage to sail cloth structures"
      },
      {
        name: image4,
        heading: "Solar Panel Damage",
        text: "Solar photovoltaic panel detached from roof mounting"
      },
      {
        name: image5,
        heading: "Aerial Damage",
        text:
          "Damage to roof cladding caused by aerial detaching from roof mounting"
      }
    ]
  }),
  methods: {
    gotoDamage() {
      router.push("/damage");
    },
    gotoAncillary() {
      router.push("/ancillary");
    }
  }
};
</script>
